import { AssistChip, Skeleton, Stack } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table/TableRow';
import { Table } from '~/components/molecules/Table';

export type IIapPollListItemSkeletonProps = ITableRowProps;

export const IapPollListItemSkeleton: React.FC<
  IIapPollListItemSkeletonProps
> = (props) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} gap={1}>
        <Skeleton length={{ min: 24, max: 32 }} />
        <Skeleton length={{ min: 24, max: 32 }} />
      </Stack>

      <Table.Body>
        <Skeleton length={{ min: 8, max: 16 }}>
          <AssistChip />
        </Skeleton>
      </Table.Body>

      <Table.Body />
    </Table.Row>
  );
};
